export enum AppointmentType {
    Messaging = 'Messaging',
    Telephonic = 'Telephonic'
}
